var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3795 3781 c-47 -22 -89 -64 -104 -104 -15 -40 -14 -122 3 -160 8 -18 174 -192 375 -392 l361 -360 -2147 -5 -2148 -5 -38 -24 c-21 -13 -50 -42 -65 -64 -23 -34 -27 -52 -27 -107 0 -55 4 -73 27 -107 15 -22 44 -51 65 -64 l38 -24 2148 -5 2147 -5 -361 -360 c-201 -200 -367 -374 -375 -392 -17 -38 -18 -120 -3 -160 36 -97 167 -149 261 -105 43 20 1104 1062 1140 1120 34 55 33 154 -3 208 -42 63 -1094 1096 -1137 1116 -48 23 -107 22 -157 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2cc723220c7976d188afebfb20d0fbcf.svg";
export { ForwardRef as ReactComponent };